import { render, staticRenderFns } from "./TermsOverviewView.vue?vue&type=template&id=5f6d5cde&"
import script from "./TermsOverviewView.vue?vue&type=script&lang=ts&"
export * from "./TermsOverviewView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports